// Module
var code = "<a href=\"javascript:;\" class=\"btn green edit-button subFormControl\"> <i class=\"fa fa-history\"></i><span data-bind=\"text: GetControlTypeTranslatedName()\"></span> </a>";
// Exports
export default code;